/**
 * Bármilyen stringből csinál kebab-case-t.
 * @example
 * toLowerCase → to-lower-case
 * @param {string} str - A string, amit átalakítunk.
 * @returns {string} Az átalakított szöveg.
 */
module.exports.toKebabCase = function toKebabCase (str) {
  return (
    str.match(/[A-Z]{2,}(?=[A-Z][a-z]|\b)|[A-Z]?[a-z]+\d*|[A-Z]|\d+/g) || []
  )
    .map((x) => x.toLowerCase())
    .join('-')
}
